export const formatFileSize = (bytes?: number | null): string | null => {
  if (bytes === null || typeof bytes === 'undefined') return null;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
};
